'use strict';

var GridStatusCustomRenderersFactory = function GridStatusCustomRenderersFactory($interpolate) {
  var statusIcons = {
    'ACTIVE': $interpolate(require('../templates/custom-renderers/status-active.html')),
    'INACTIVE': $interpolate(require('../templates/custom-renderers/status-inactive.html')),
    'DISABLED': $interpolate(require('../templates/custom-renderers/status-disabled.html'))
  };
  var statusRenderer = function statusRenderer(columnContext, row, columnfield, value, defaultvalue) {
    var data = {
      uid: row,
      fieldId: columnfield
    };
    return defaultvalue.replace('>' + value + '<', '>' + statusIcons[value.toUpperCase()](data) + '<');
  };
  return {
    status: statusRenderer
  };
};
GridStatusCustomRenderersFactory.$inject = ['$interpolate'];
module.exports = GridStatusCustomRenderersFactory;